/**
 * 判断是否运行在 iframe 中
 * @returns
 */
export function isInIframe() {
    return window.self !== window.top;
}

/**
 * 判断是否 AI Agent Flow 中
 * @description 是否运行在 url 包含 ‘ai/agent-flow/’ 的 iframe 中
 * @returns
 */
export function isInAiAgentFlowIframe() {
    return isInIframe() && window.parent.location.href.includes('ai/agent-flow/');
}
